import mainApiClient from '../interceptor.mainApiClient';

const patternClusteringEndpoints = {
  getFeatures: (alienId, config) =>
    mainApiClient.get(`/api/v1/patternclustering/features/${alienId}`, config),

  getAssignment: (alienId, config) =>
    mainApiClient.get(`/api/v1/patternclustering/assignment/${alienId}`, config),

  getProfile: (clusterId, config) =>
    mainApiClient.get(`/api/v1/patternclustering/profile/${clusterId}`, config),

  getAllProfiles: (config) =>
    mainApiClient.get(`/api/v1/patternclustering/profiles`, config),

  getVisualization: (config) =>
    mainApiClient.get(`/api/v1/patternclustering/visualization`, config),

  train: (data, config) =>
    mainApiClient.post(`/api/v1/patternclustering/train`, data, config),

  cluster: (data, config) =>
    mainApiClient.post(`/api/v1/patternclustering/cluster`, data, config),
};

export default patternClusteringEndpoints;
